import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getEstablishmentTypeList as getEstablishmentTypeListApi,
	getEstablishmentType as getEstablishmentTypeApi,
	addNewEstablishmentType as addNewEstablishmentTypeApi,
	updateEstablishmentType as updateEstablishmentTypeApi,
	deleteEstablishmentType as deleteEstablishmentTypeApi,
	getProductiveCycleActive as getProductiveCycleActiveApi,
	getEstablishmentTypeCodes as getEstablishmentTypeCodesApi,
} from '../../helpers/establishment/backend_helper';

export const getEstablishmentTypeList = createAsyncThunk('establishmentTypes/getEstablishmentTypeList', async (params) => {
	try {
		const response = getEstablishmentTypeListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getEstablishmentType = createAsyncThunk('establishmentTypes/getEstablishmentType', async establishmentType_id => {
	try {
		const response = getEstablishmentTypeApi(establishmentType_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewEstablishmentType = createAsyncThunk('establishmentTypes/addNewEstablishmentType', async establishmentType => {
	try {
		const response = addNewEstablishmentTypeApi(establishmentType);
		toast.success('Establecimiento agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar establishmentType.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateEstablishmentType = createAsyncThunk('establishmentTypes/updateEstablishmentType', async (establishmentType) => {
		try {
			const response = updateEstablishmentTypeApi(establishmentType);
			if (response?.status === 200) {
        toast.success('Establecimiento actualizado exitosamente', { autoClose: 3000 });
      }
			return response;
		} catch (error) {
			toast.error('Error al actualizar establishmentType.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteEstablishmentType = createAsyncThunk('establishmentTypes/deleteEstablishmentType', async establishmentType => {
	try {
		const response = await deleteEstablishmentTypeApi(establishmentType);
		toast.success('Establecimiento eliminado exitosamente.', { autoClose: 3000 });
		return { establishmentType, ...response };
	} catch (error) {
		toast.error('Error al eliminar establishmentType.', { autoClose: 3000 });
		throw new Error(error);
	}
});



export const getEstablishmentTypeCodes = createAsyncThunk('powerGenerationType/getEstablishmentTypeCodes', async (codes) => {
	try {
		const response = getEstablishmentTypeCodesApi(codes);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

